/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Wed Apr 24 2024
 **/

import React from "react";

import { Button, Column, Row, Typography } from "@/frameworks/designStuff/components";
import { _T } from "@rfice/language";

type ConfirmProps = {
	onHide: () => void;
	onConfirm: (e: React.MouseEvent<HTMLButtonElement>) => void;
	onCancel?: (e: React.MouseEvent<HTMLButtonElement>) => void;
	confirmContent?: string;
	cancelContent?: string;
};
export default function Confirm({
	onCancel,
	onConfirm,
	onHide,
	children,
	confirmContent = _T("확인"),
	cancelContent = _T("취소")
}: React.PropsWithChildren<ConfirmProps>) {
	const handleCancel = (e: React.MouseEvent<HTMLButtonElement>) => {
		onHide();
		onCancel?.(e);
	};
	const handleConfirm = (e: React.MouseEvent<HTMLButtonElement>) => {
		onHide();
		onConfirm(e);
	};

	return (
		<Column horizonAlign="center" gap={14} css={{ padding: "24px" }}>
			{children && <Typography typoSize="Title3">{children}</Typography>}
			<Row gap={6}>
				<Button onClick={handleCancel} filled="secondary">
					{cancelContent}
				</Button>
				<Button onClick={handleConfirm}>{confirmContent}</Button>
			</Row>
		</Column>
	);
}
